import React from 'react';
import PropTypes from 'prop-types';
import hdate from 'human-date';
import { getMemberPriceStampInfoFromMemberName } from '../../../lib/utils';
import styles from './ReportedBy.module.css';

export default function ReportedBy({ username, time }) {
  const { iconPath, linkUrl } = getMemberPriceStampInfoFromMemberName(username);
  const UserElement = username ? 'a' : 'span';

  return (
    <div>
      <span className={styles.user}>
        <UserElement className={styles.memberLink} href={username && linkUrl}>
          <img src={iconPath} alt="Price Reporter Icon" />
          &nbsp;
          {username || 'No Report'}
        </UserElement>
      </span>
      <span className={styles.postedTime}>
        {time ? hdate.relativeTime(time) : 'N/A'}
      </span>
    </div>
  );
}

ReportedBy.propTypes = {
  username: PropTypes.string,
  time: PropTypes.string,
};

ReportedBy.defaultProps = {
  username: undefined,
  time: undefined,
};
